import { connect } from 'react-redux';
import { isGuestTmp } from '../../../base/conference/functions';
import { openDialog } from '../../../base/dialog/actions';
import { translate } from '../../../base/i18n/functions';
import { IconWhiteboard, IconWhiteboardHide } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { NOTIFICATION_TIMEOUT_TYPE, showNotification } from '../../../notifications';
import { setOverflowMenuVisible } from '../../../toolbox/actions.web';
import { isWhiteboardButtonVisible, isWhiteboardVisible } from '../../functions';
import DialogManagerWhiteboard from './DialogManagerWhiteboard';
/**
 * Component that renders a toolbar button for the whiteboard.
 */
class WhiteboardButton extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.showWhiteboard';
        this.toggledAccessibilityLabel = 'toolbar.accessibilityLabel.hideWhiteboard';
        this.icon = IconWhiteboard;
        this.label = 'toolbar.showWhiteboard';
        this.toggledIcon = IconWhiteboardHide;
        this.toggledLabel = 'toolbar.hideWhiteboard';
        this.toggledTooltip = 'toolbar.hideWhiteboard';
        this.tooltip = 'toolbar.showWhiteboard';
    }
    /**
     * Handles clicking / pressing the button, and opens / closes the whiteboard view.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        const { dispatch, _toggled, conference, isLocalSharingWhiteboard } = this.props;
        if (isGuestTmp())
            return dispatch(showNotification({
                titleKey: 'whiteboard.noti.whiteboard',
                descriptionKey: 'whiteboard.noti.loginRequired'
            }, NOTIFICATION_TIMEOUT_TYPE.SHORT));
        if (_toggled && !isLocalSharingWhiteboard)
            return dispatch(showNotification({
                titleKey: 'whiteboard.noti.whiteboard',
                descriptionKey: 'whiteboard.noti.isShared'
            }, NOTIFICATION_TIMEOUT_TYPE.SHORT));
        if (_toggled) {
            conference && conference.closeWhiteboard();
        }
        else {
            dispatch(openDialog(DialogManagerWhiteboard));
            dispatch(setOverflowMenuVisible(false));
        }
    }
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._toggled;
    }
}
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state) {
    const { conference } = state['features/base/conference'];
    const { openUserId } = state['features/whiteboard'];
    return {
        _toggled: isWhiteboardVisible(state),
        visible: isWhiteboardButtonVisible(state) || true,
        conference,
        isLocalSharingWhiteboard: openUserId === JSON.parse(localStorage.getItem("user") || "local")?.id
    };
}
export default translate(connect(_mapStateToProps)(WhiteboardButton));
